const handovertemplate = {
	name: 'Übergabeprotokoll Vorlagen',
	fields: {
		name: 'Bezeichnung',
		rooms_count: 'Räume',
	},
}

export default handovertemplate
